import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Menu, MenuItem } from '@workboard/wobo-ui';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
import { MemberRequestResponse } from '../../../../types/teams-management';

type ApproveMenuProps = {
  memberRequestIdsToApprove: number[];
  handleMemberRequestResponse: (
    requestsToApprove: MemberRequestResponse[],
  ) => Promise<void>;
};

const ApproveMenuDiv = styled('div')`
  padding: 5px;
  position: relative;
`;

export const ApproveMenu = ({
  memberRequestIdsToApprove,
  handleMemberRequestResponse,
}: ApproveMenuProps): JSX.Element => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const toggleMenuOpen = (e): void => {
    if (isOpen) {
      setIsOpen(false);
      setAnchorEl(null);
    } else {
      setIsOpen(true);
      setAnchorEl(e.currentTarget);
    }
  };
  const closeMenu = (): void => {
    setIsOpen(false);
    setAnchorEl(null);
  };
  const approve = (): Promise<void> =>
    handleMemberRequestResponse(
      memberRequestIdsToApprove.map((id) => ({
        id,
        status: 'approved',
        approval_type: 'team_member',
      })),
    );
  const approveAsManager = (): Promise<void> =>
    handleMemberRequestResponse(
      memberRequestIdsToApprove.map((id) => ({
        id,
        status: 'approved',
        approval_type: 'comanager',
      })),
    );
  const approveAsAdmin = (): Promise<void> =>
    handleMemberRequestResponse(
      memberRequestIdsToApprove.map((id) => ({
        id,
        status: 'approved',
        approval_type: 'admin',
      })),
    );
  const reject = (): Promise<void> =>
    handleMemberRequestResponse(
      memberRequestIdsToApprove.map((id) => ({
        id,
        status: 'rejected',
      })),
    );

  return (
    <ApproveMenuDiv>
      <Button variant="tertiary" onClick={toggleMenuOpen}>
        {t('Approve')} <KeyboardArrowDown />
      </Button>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        id="memberRequestApproveMenu"
        keepMounted
        onClose={closeMenu}
        open={isOpen}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      >
        <MenuItem onClick={approve}>{t('Approve as a team member')}</MenuItem>
        <MenuItem onClick={approveAsManager}>
          {t('Approve and make co-manager')}
        </MenuItem>
        <MenuItem onClick={approveAsAdmin}>
          {t('Approve and make admin')}
        </MenuItem>
      </Menu>
      <Button
        style={{ marginLeft: '10px' }}
        onClick={reject}
        variant="tertiary"
      >
        {t('Reject')}
      </Button>
    </ApproveMenuDiv>
  );
};

export default ApproveMenu;
